import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ChildActivationEnd, NavigationStart, Router, RouterEvent } from '@angular/router';
import { filter, pairwise } from 'rxjs/operators';
import {IdelTimeoutService} from './services/idel-timeout.service';
import { environment } from "../environments/environment";
import { ConsoleToggleService } from './services/console-toggle.service';
import { ThemeRuntimeService } from "./services/theme-runtime.service";

declare global {
    interface Window {
        dataLayer: any[];
        gtag: (...args: any[]) => void;
        _gs?: (...args: any[]) => void;
    }
}

@Component({
    selector: 'app-root',
    template: `
        <sbpro-toast-view class="ngb-toasts" aria-live="polite" aria-atomic="true">
        </sbpro-toast-view
        ><router-outlet></router-outlet>
    `,
    standalone: false
})
export class AppComponent implements  OnInit ,  OnDestroy {
    company = '';
    constructor(public router: Router, private titleService: Title, private renderer: Renderer2 , private idelTimeOutService:IdelTimeoutService , private consoleToggleService:ConsoleToggleService, private themeRuntimeService: ThemeRuntimeService) {
      //this.consoleToggleService.disableConsoleInProduction(); 
        
         // setInterval(() => {
        //     if (window.outerHeight - window.innerHeight > 200 || window.outerWidth - window.innerWidth > 200) {
        //       console.warn("DevTools detected! Security warning.");
        //     }
        //   }, 1000);
        this.router.events
            .pipe(filter((event) => event instanceof ChildActivationEnd))
            .subscribe((event) => {
                let snapshot = (event as ChildActivationEnd).snapshot;

                while (snapshot.firstChild !== null) {
                    snapshot = snapshot.firstChild;
                }
                const routeTitle = snapshot.data.title || 'Utility Management Software | Smart-View Technology';
                const activeCompany = environment.companyCheck === 'eykon'
                    ? 'eykon'
                    : localStorage.getItem('company') || environment.companyCheck;
                const title = activeCompany === 'eykon'
                    ? routeTitle.replace(/Landis Gyr(?: \| Smart-View Technology)?|Smart-View Technology/g, 'Eykon')
                    : routeTitle;

                this.titleService.setTitle(title);
            });
    }
    ngOnDestroy(){
    }
  
    injectFacebookPixel() {
        console.log("Facebook Pixel");
        const fbScript = document.createElement('script');
        fbScript.innerHTML = `
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '596942717642540');
            fbq('trackCustom', 'Smart Utilities Campaign');
        `;
        document.head.appendChild(fbScript);
    }

    injectGoogleTagManager() {
        console.log("Google Tag Manager");
        const gtmScript = document.createElement('script');
        gtmScript.async = true;
        gtmScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-VPPEHKT6LC';
        document.head.appendChild(gtmScript);
        
        const gtmConfigScript = document.createElement('script');
        gtmConfigScript.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-VPPEHKT6LC');
        `;
        document.head.appendChild(gtmConfigScript);
    }

    setupGistTracking() {
        console.log("Gist Tracking");
        const email = localStorage.getItem("email") || "demo@smartviewtechnology.co.za";
        const userID = localStorage.getItem("userID") || "";

        if (typeof window !== 'undefined' && typeof window._gs === 'function') {
            const trackingScript = document.createElement('script');
            trackingScript.innerHTML = `
                _gs('identify', {
                    email: '${email}',
                    name: '${email}',
                    custom: {
                        any: 'userID',
                        properties: '${userID}'
                    }
                });
            `;
            document.head.appendChild(trackingScript);
        } else {
            console.warn('Gist tracking is unavailable: _gs is not defined.');
        }
    }

    injectNoscriptTagsIntoBody() {
        console.log("Noscript Tags");
        const facebookNoscript = document.createElement('noscript');
        facebookNoscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=596942717642540&ev=PageView&noscript=1" />`;
        document.body.appendChild(facebookNoscript);
      
        const gtmNoscriptProd = document.createElement('noscript');
        gtmNoscriptProd.id = 'prod';
        gtmNoscriptProd.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=G-VPPEHKT6LC" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
        document.body.appendChild(gtmNoscriptProd);
      
        const gtmNoscriptTest = document.createElement('noscript');
        gtmNoscriptTest.id = 'testing';
        gtmNoscriptTest.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=G-VPPEHKT6LC&gtm_auth=YDCCZoVHraAj5tywVTG5Bg&gtm_preview=env-24&gtm_cookies_win=x" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
        document.body.appendChild(gtmNoscriptTest);
    }

    injectLinkedInTracking() {
        // LinkedIn's tracker is optional telemetry. Do not load it during local
        // development, where browser privacy blockers commonly reject the
        // third-party script and surface an unhandled promise error.
        const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
        const isLocalHost = hostname === 'localhost'
            || hostname === '127.0.0.1'
            || hostname === '0.0.0.0'
            || hostname === '::1';
        if (!environment.production || isLocalHost) {
            return;
        }

        console.log("LinkedIn Tracking");
        const linkedinScript1 = document.createElement('script');
        linkedinScript1.type = 'text/javascript';
        linkedinScript1.text = `
          _linkedin_partner_id = "4611113";
          window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
          window._linkedin_data_partner_ids.push(_linkedin_partner_id);
        `;
        document.body.appendChild(linkedinScript1);
      
        const linkedinScript2 = document.createElement('script');
        linkedinScript2.type = 'text/javascript';
        linkedinScript2.text = `
          (function (l) {
            if (!l) {
              window.lintrk = function (a, b) { window.lintrk.q.push([a, b]) };
              window.lintrk.q = []
            }
            var s = document.getElementsByTagName("script")[0];
            var b = document.createElement("script");
            b.type = "text/javascript"; b.async = true;
            b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
            b.onerror = function () {
              // Analytics failures must never affect application startup.
              console.warn('LinkedIn tracking is unavailable.');
            };
            s.parentNode.insertBefore(b, s);
          })(window.lintrk);
        `;
        document.body.appendChild(linkedinScript2);
      
        const linkedinNoscript = document.createElement('noscript');
        linkedinNoscript.innerHTML = `<img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=4611113&fmt=gif" />`;
        document.body.appendChild(linkedinNoscript);
    }

    injectStatusPageScript() {
        const existingScript = document.querySelector(
          'script[src="https://7f64x3tyb4bn.statuspage.io/embed/script.js"]'
        );
        if (existingScript) return; // Avoid adding it twice
      
        const script = document.createElement('script');
        script.src = 'https://7f64x3tyb4bn.statuspage.io/embed/script.js';
        script.async = true;
        script.defer = true;
      
        document.body.appendChild(script);
    }
      
    ngOnInit() {
        this.company = environment.companyCheck === 'eykon'
            ? 'eykon'
            : localStorage.getItem('company') || environment.companyCheck;
        const isLoggedIn = !!localStorage.getItem('userID');
        // Change the favicon when the component is initialized based on the condition
        this.updateTitleAndFavicon(this.company!);
        if (this.company !== "landis" && this.company !== "eykon" && isLoggedIn) {
            // Chat/support widget loader kept commented out so the button stays hidden
            // without removing the integration hook entirely.
            // const script1 = document.createElement("script");
            // script1.type = "text/javascript";
            // script1.async = true;
            // script1.defer = true;
            // script1.src = "//js-eu1.hs-scripts.com/40115116.js";
            // document.body.appendChild(script1);

            // if (!document.getElementById("hs-script-loader")) {
            //   const script2 = document.createElement("script");
            //   script2.type = "text/javascript";
            //   script2.id = "hs-script-loader";
            //   script2.async = true;
            //   script2.defer = true;
            //   script2.src = "//js-eu1.hs-scripts.com/40115116.js";
            //   document.body.appendChild(script2);
            // }

            this.injectFacebookPixel();
            this.injectGoogleTagManager();
            this.setupGistTracking(); 
            this.injectNoscriptTagsIntoBody();
            this.injectLinkedInTracking();
            this.injectStatusPageScript();
        }

        // Load Google Maps Scripts
        const googleMapScript = document.createElement('script');
        googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=${environment.GOOGLE_MAPS_API_KEY}&libraries=places,drawing,geometry`;
        googleMapScript.defer = true;
        googleMapScript.async = true;
        googleMapScript.onload = () => {
            console.log('Google Maps API loaded');
        };
        document.body.appendChild(googleMapScript);

        this.router.events
        .pipe(
        // Only NavigationStart events pass through
        filter(event => event instanceof NavigationStart),
        pairwise()
        )
        .subscribe(([previous, current]) => {
            const prevNav = previous as NavigationStart;
            const currNav = current as NavigationStart;

            if (prevNav.url === '/dashboard/reporting') {
                const farmMeteringSection:any = localStorage.getItem('farmMeteringSection')
                if(farmMeteringSection){
                let meteringSectionName:any = localStorage.getItem('farmMeteringSection')
                localStorage.setItem('meteringSection', meteringSectionName);
                } 
            }
        });
    }
    
    updateTitleAndFavicon(condition: string) {
        // Set title based on condition
        const title = condition == 'eykon'
            ? 'Utility Management Software | Eykon'
            : condition == 'landis'
                ? 'Utilities Management Software | Landis Gyr | Smart-View Technology'
                : 'Utility Management Software | Smart-View Technology';

        this.titleService.setTitle(title);

        // Update favicon based on condition
        const activeBranding = this.themeRuntimeService.getActiveBranding();
        const faviconUrl = activeBranding?.favicon || (condition === 'eykon'
            ? 'assets/eykon-assets/images/eykon-favicon.ico?v=20261015'
            : condition === 'landis'
                ? 'assets/landis-assets/images/favicon.png'
                : 'assets/branding/favicon.ico?v=5301');
        this.updateFavicon(faviconUrl);
    }

    updateFavicon(faviconUrl: string) {
        if (faviconUrl === 'favicon.png' || faviconUrl === '/favicon.png') {
            faviconUrl = 'assets/branding/favicon.ico?v=5301';
        }
        const links = document.querySelectorAll<HTMLLinkElement>("link[rel~='icon']");
        if (links.length === 1 && links[0].href === new URL(faviconUrl, document.baseURI).href) {
            return;
        }
        links.forEach(link => link.remove());

        const link: HTMLLinkElement = this.renderer.createElement('link');
        link.setAttribute('rel', 'icon');
        link.setAttribute('href', faviconUrl);
        const head = this.renderer.selectRootElement('head', true);
        this.renderer.appendChild(head, link);
    }
}
